@if (!conversionTable?.Id) {
  <h1>New Conversion Table</h1>
}
@if (conversionTable?.Id) {
  <h1>{{conversionTable?.Name}}</h1>
}
<form #conversionTableForm="ngForm" name="conversionTableForm" (ngSubmit)="conversionTableForm.valid && save(conversionTableForm)" novalidate>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label>Name *</label>
          <input id="inputNameNewConversionTable" class="form-control" [ngClass]="{'invalid-state-border':name.errors}" name="name" #name="ngModel" required type="text" [ngModel]="$safeNavigationMigration(clonedConversionTable?.Name)" (ngModelChange)="clonedConversionTable.Name = $event" />
          @if (name.errors && (name.dirty || name.touched || conversionTableForm.submitted)) {
            <div class="error">Please enter the name</div>
          }
        </div>
        <div class="form-group" *bizPermissionRequired="'Partner_Action_ConversionTableStructureEditUniversal'">
          <div class="control control-checkbox lg control-form-group" [title]="conversionTable?.IsUniversal ? 'An already saved universal conversion table can not be made non-universal' : ''">
            <label>Is Universal<input type="checkbox" name="IsUniversal" [ngModel]="$safeNavigationMigration(clonedConversionTable?.IsUniversal)" (ngModelChange)="clonedConversionTable.IsUniversal = $event" [disabled]="$safeNavigationMigration(conversionTable?.IsUniversal)" /><i></i></label>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label>Description *</label>
          <textarea id="textareaDiscriptionNewConversionTable" [ngClass]="{'invalid-state-border':description.errors}" name="description" #description="ngModel" required rows="5" class="form-control" [ngModel]="$safeNavigationMigration(clonedConversionTable?.Description)" (ngModelChange)="clonedConversionTable.Description = $event"></textarea>
          @if (description.errors && (description.dirty || description.touched || conversionTableForm.submitted)) {
            <div class="error">Please enter the description</div>
          }
        </div>
      </div>
    </div>
    <hr />
    <label>Columns</label>
    <div class="row">
      <dx-data-grid [selection]='{ mode: "single" }'
        [dataSource]='$safeNavigationMigration(clonedConversionTable?.Columns)'
        (onRowRemoved)="onRowRemoved($event)"
        (onInitNewRow)="onInitNewRow($event)">
        <dxo-editing mode="row"
          [allowUpdating]="true"
          [allowAdding]="true"
          [allowDeleting]="true">
        </dxo-editing>

        <dxi-column dataField="ColumnName" width="150" caption="Name" dataType="string" [validationRules]="[{ type: 'required' }]"></dxi-column>
        <dxi-column dataField="SortOrder" width="80" caption="Order" dataType="number" [validationRules]="[{ type: 'required' }]"></dxi-column>
        <dxi-column dataField="Description" caption="Description" dataType="string"></dxi-column>
      </dx-data-grid>

    </div>
  </div>
  <hr />
  <div>
    <button id="btnSaveNewConversionTable" class="btn btn-primary" type="submit">Save</button>
    <button id="btnCancelNewConversionTable" class="btn btn-link" (click)="cancel()">Cancel</button>
  </div>
</form>
